<template>
    <div class="x_box">
        <ol class="breadcrumb x_breadcrumb">
            <li class="breadcrumb-item">
                <router-link to="/expenses">{{ $t('expense_list') }}</router-link>
            </li>
            <li class="breadcrumb-item active" aria-current="page">{{ $t('expense_create') }}</li>
        </ol>
        <div class="x_header">
            <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="$router.go(-1)"><i class="fa fa-arrow-circle-o-left"></i> {{ $t('back') }}</button> 
            <template v-if="header.Status=='Draft'">
                <router-link :to="{ name: 'expense_edit', params: { id: $route.params.id }}" class="btn btn-outline-primary btn-sm no-bor"><i class="fa fa-pencil"></i> {{$t('edit')}}</router-link>
                <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="onApproval"><i class="fa fa-check"></i> {{ $t('approval') }}</button>
            </template>
        </div>
        <div class="x_body">
            <div class="card f_card">
                <div class="card-body">
                    <form ref="form">
                        <div class="row">
                            <div class="col-sm-4">
                                <table class="table">
                                    <tbody>
                                        <tr>
                                            <th style="width: 120px;">{{$t('date')}}</th>
                                            <th style="width: 10px;">:</th>
                                            <td>{{$format(header.Date,'DD/MM/YYYY')}}</td>
                                        </tr>
                                        <tr>
                                            <th>{{$t('code')}}</th>
                                            <th>:</th>
                                            <td>{{header.Num}}</td>
                                        </tr>
                                        <tr>
                                            <th>{{$t('payment_menthod')}}</th>
                                            <th>:</th>
                                            <td>{{header.AccountName}}</td>
                                        </tr>
                                        <tr>
                                            <th>{{$t('expense_type')}}</th>
                                            <th>:</th>
                                            <td>{{lines[0].AccountName}}</td>
                                        </tr>
                                        <tr>
                                            <th>{{$t('amount')}}</th>
                                            <th>:</th>
                                            <td>{{$money(header.Amount)}}</td>
                                        </tr>
                                        <tr>
                                            <th>{{$t('description')}}</th>
                                            <th>:</th>
                                            <td>{{header.Description}}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        data: function(){
            return {
                header:{
                    Status: ''
                },
                lines: []
            }
        },
        created: function(){
            this.findById(this.$route.params.id);
        },
        methods: {
            findById(id){
                var loading = this.$loading.show();
                this.$api().post('accounting/bill/find', { Id: id }).then(res => {
                    if(this.$isValid(res)){
                        this.header = res.data.Json.Header;
                        this.lines = res.data.Json.Lines;
                    }
                }).finally(function(){ loading.hide(); });
            },
            onApproval(){
                var loading = this.$loading.show();
                this.$api().post('accounting/bill/approve', { Id: this.$route.params.id }).then(res => {
                    if(this.$isValid(res)){
                        this.$router.go(-1);
                    }
                }).finally(function(){ loading.hide(); });
            }
        },
    }
</script>